import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAtomValue } from "jotai";
import { userAtom } from "../../atoms/appAtoms";
import AppContact from "@nualang/nualang-ui-components/dist/Forms/AppContact/AppContact";
import Snackbar from "@nualang/nualang-ui-components/dist/Misc/Snackbar";
import NualasLineUp from "../../img/nualas.svg";
import { styled } from "@mui/material/styles";
import { Box, Grid, Typography } from "@mui/material";
import { appContactEmail } from "@nualang/nualang-api-and-queries/APIs/Notifications";
import { parseUserAgent } from "react-device-detect";

const NualasHeroImg = styled("img")(({ theme }) => ({
  maxHeight: "200px",
  textAlign: "center",
  marginTop: theme.spacing(2),
}));

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  margin: theme.spacing(3),
}));

function Contact(props) {
  const { authenticated } = props;
  const { t } = useTranslation();
  const user = useAtomValue(userAtom);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [values, setValues] = useState({
    email: user ? user.attributes.email : "",
    username: user ? user.attributes["preferred_username"] : "",
    role: user ? user.attributes["custom:role"] : "",
    message: "",
    browser: JSON.stringify(parseUserAgent(window.navigator.userAgent).browser),
    os: JSON.stringify(parseUserAgent(window.navigator.userAgent).os),
    isWaysideUser: user?.username?.startsWith("Wayside"),
  });

  useEffect(() => {
    if (user?.username) {
      setValues((prevValues) => ({
        ...prevValues,
        email: user.attributes.email,
        username: user.attributes["preferred_username"],
        role: user.attributes["custom:role"],
        isWaysideUser: user.username.startsWith("Wayside"),
      }));
    } else {
      setValues({
        email: "",
        username: "",
        role: "",
        isWaysideUser: false,
      });
    }
  }, [user]);

  const handleSubmit = async () => {
    const { jobTitle, ...payload } = values;
    if (jobTitle && jobTitle !== "") {
      // Bot detectd via honeypot, do not proceed
      setSubmitted(true);
    } else {
      if (!payload.message) {
        payload.message = "No Message";
      }
      setIsLoading(true);
      const response = await appContactEmail(payload);
      setIsLoading(false);

      if (response.MessageId) {
        setSubmitted(true);
      } else {
        setSnackbarOpen(true);
      }
    }
  };

  return (
    <React.Fragment>
      <Root>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 10 }}>
            <Box sx={{
              p: 2
            }}>
              <Typography variant="h4" gutterBottom>
                {t("contact_us")}
              </Typography>
              <Typography variant="subtitle1" gutterBottom>
                {t("contact_us_message")}
              </Typography>
              <NualasHeroImg src={NualasLineUp} alt="NualasLineUp" />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 8 }}>
            <AppContact
              t={t}
              authenticated={authenticated}
              handleSubmit={handleSubmit}
              submitted={submitted}
              values={values}
              setValues={setValues}
              isLoading={isLoading}
              id="contact-form"
              authEmail={user.attributes.email || ""}
            />
          </Grid>
        </Grid>
      </Root>
      <Snackbar
        t={t}
        isSnackbarOpen={snackbarOpen}
        closeSnackbar={() => setSnackbarOpen(false)}
        snackbarMessage={t("problem_sending_contact_form")}
        snackbarType={"error"}
      />
    </React.Fragment>
  );
}

export default Contact;
